import { StyledButton } from "@aureskonnect/react-ui";
import { t } from "i18next";

import React from "react";

export default function LocalSettingFooter({
    handleCloseModal,
    handleOnClickEvent,
}: {
    handleCloseModal: () => void;
    handleOnClickEvent: () => void;
}): JSX.Element {
    return (
        <div className="d-flex align-items-center justify-content-center">
            {/* Leave Button */}
            <StyledButton
                rounded={true}
                className="m-2"
                style={{
                    width: "179px",
                    height: "60px",
                    fontSize: "18px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px",
                    borderRadius: "12px",
                    border: "1px solid #e5e7eb",
                    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.2s ease",
                    background: "#ffffff",
                    color: "#1f2937",
                    fontFamily: "Segoe UI, sans-serif",
                    letterSpacing: "0.5px",
                    cursor: "pointer",
                }}
                onClick={handleCloseModal}
            >
                {t("Leave")}
            </StyledButton>

            {/* Save Button */}
            <StyledButton
                rounded={true}
                className="m-2"
                style={{
                    width: "179px",
                    height: "60px",
                    fontSize: "18px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px",
                    borderRadius: "12px",
                    border: "none",
                    boxShadow: "0 10px 25px -5px rgba(7, 125, 188, 0.4)",
                    transition: "all 0.2s ease",
                    background:
                        "linear-gradient(135deg, #077dbc 0%, #075d9b 100%)",
                    color: "#ffffff",
                    fontFamily: "Segoe UI, sans-serif",
                    letterSpacing: "0.5px",
                    marginRight: "0px",
                    cursor: "pointer",
                }}
                onClick={handleOnClickEvent}
            >
                {t("Save")}
            </StyledButton>
        </div>
    );
}
